var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1201",
    "data-name": "Grupo 1201",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.811,
    height: 23.767,
    viewBox: "0 0 23.811 23.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1807",
    "data-name": "Trazado 1807",
    d: "M18.766,16.784a2.376,2.376,0,0,0-3.366,0l-1.148,1.148a20.7,20.7,0,0,1-3.572-2.867,21.082,21.082,0,0,1-2.867-3.572l1.148-1.148a2.376,2.376,0,0,0,0-3.366L6.72,4.746a2.32,2.32,0,0,0-1.671-.7h0a2.376,2.376,0,0,0-1.687.7L2.285,5.815a5.045,5.045,0,0,0-1.3,4.158c.253,2.97,2.2,6.542,5.2,9.551s6.613,4.95,9.583,5.235a6.233,6.233,0,0,0,.665,0,4.807,4.807,0,0,0,3.493-1.3L21,22.383a2.376,2.376,0,0,0,.7-1.687,2.32,2.32,0,0,0-.7-1.671Zm1.117,4.482-1.077,1.069a3.619,3.619,0,0,1-2.9.792c-2.574-.222-5.853-2.043-8.561-4.752S2.816,12.412,2.57,9.838a3.588,3.588,0,0,1,.792-2.9L4.479,5.863a.792.792,0,0,1,.562-.23h0a.792.792,0,0,1,.562.23L7.845,8.128a.792.792,0,0,1,0,1.117L6.261,10.828a.792.792,0,0,0-.127.958,21.771,21.771,0,0,0,3.429,4.419,21.771,21.771,0,0,0,4.419,3.429.792.792,0,0,0,.958-.127l1.584-1.584a.792.792,0,0,1,1.117,0l2.241,2.241h0a.774.774,0,0,1,0,1.1ZM21.26,4.477A11.816,11.816,0,0,0,12.866,1a.792.792,0,0,0,0,1.584,10.3,10.3,0,0,1,10.3,10.382.792.792,0,0,0,.792.792h0a.792.792,0,0,0,.792-.792,11.808,11.808,0,0,0-3.485-8.49Z",
    transform: "translate(-0.934 -1)",
    fill: "#e73758"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1808",
    "data-name": "Trazado 1808",
    d: "M19.822,10.321a4.752,4.752,0,0,1,1.4,3.413.792.792,0,0,0,.792.792h0a.792.792,0,0,0,.792-.792A6.336,6.336,0,0,0,16.472,7.32a.792.792,0,1,0,0,1.584,4.752,4.752,0,0,1,3.35,1.418Z",
    transform: "translate(-4.002 -2.315)",
    fill: "#e73758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.31d504f82e68d1b7d8ec23d5f03ad59f.svg";
export { ForwardRef as ReactComponent };